(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function applyVariantCard(item) {
    if (!item.dataset.variantId) return;

    const variantId = item.dataset.variantId;
    const variantImage = item.dataset.variantImage;
    const variantColor = item.dataset.variantColor;

    const link = item.querySelector('a.product-card__link, a.product-grid__link');
    if (link && variantId) {
      const u = new URL(link.href);
      u.searchParams.set('variant', variantId);
      link.href = u.toString();
    }

    const productCard = item.querySelector('product-card');

    if (variantImage && variantColor && productCard) {
      const img = item.querySelector('.product-media-container img');
      if (img) {
        img.src = variantImage;
        img.srcset = variantImage;
      }

      const slideshow = productCard.refs && productCard.refs.slideshow;
      if (slideshow) {
        const color = variantColor.toLowerCase();
        const slides = Array.from((slideshow.refs && slideshow.refs.slides) || []);
        var firstColorSlide = null;
        for (var i = 0; i < slides.length; i++) {
          var img2 = slides[i].querySelector('img');
          var alt = img2 ? img2.alt.toLowerCase().trim() : '';
          if (alt.indexOf(color) !== -1) { firstColorSlide = slides[i]; break; }
        }
        if (firstColorSlide) {
          slideshow.select({ id: firstColorSlide.getAttribute('slide-id') }, undefined, { animate: false });
        }
      }
    }

    const inputs = item.querySelectorAll('input[type="radio"]');
    inputs.forEach(function(input) { input.checked = false; });
    const correctInput = item.querySelector('input[data-variant-id="' + variantId + '"]');
    if (correctInput) {
      correctInput.checked = true;
    } else if (variantColor) {
      const colorInput = item.querySelector('input[value="' + variantColor + '"]');
      if (colorInput) colorInput.checked = true;
    }

    const badgeContainer = item.querySelector('.product-badges');
    if (badgeContainer) {
      const isAvailable = item.dataset.colorAvailable === 'true';
      badgeContainer.querySelectorAll('.product-badges__badge').forEach(function(b) {
        if (b.textContent.trim().toLowerCase() === 'agotado') b.remove();
      });
      if (!isAvailable) {
        const badge = document.createElement('div');
        badge.className = 'product-badges__badge product-badges__badge--rectangle color-scheme-3 badge--sold-out';
        badge.textContent = 'Agotado';
        badgeContainer.appendChild(badge);
      }
    }

    if (variantColor && productCard) {
      productCard.previewImage = function(event) {
        if (event.pointerType !== 'mouse') return;
        var slideshow = this.refs && this.refs.slideshow;
        if (!slideshow) return;
        this.resetVariant.cancel();
        var li = this.closest('[data-variant-color]');
        var c = li ? li.getAttribute('data-variant-color').toLowerCase() : null;
        if (!c) { slideshow.next(undefined, { animate: false }); return; }
        var slides = Array.from((slideshow.refs && slideshow.refs.slides) || []);
        var colorSlides = [];
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          var alt = img ? img.alt.toLowerCase().trim() : '';
          if (alt.indexOf(c) !== -1) colorSlides.push(slides[i]);
        }
        if (colorSlides.length >= 2) {
          slideshow.select({ id: colorSlides[1].getAttribute('slide-id') }, undefined, { animate: false });
        } else {
          slideshow.next(undefined, { animate: false });
        }
      };

      productCard.resetImage = function(event) {
        if (event.pointerType !== 'mouse') return;
        var slideshow = this.refs && this.refs.slideshow;
        if (!slideshow) return;
        var li = this.closest('[data-variant-color]');
        var c = li ? li.getAttribute('data-variant-color').toLowerCase() : null;
        if (!c) { slideshow.previous(undefined, { animate: false }); return; }
        var slides = Array.from((slideshow.refs && slideshow.refs.slides) || []);
        var first = null;
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          var alt = img ? img.alt.toLowerCase().trim() : '';
          if (alt.indexOf(c) !== -1) { first = slides[i]; break; }
        }
        if (first) {
          slideshow.select({ id: first.getAttribute('slide-id') }, undefined, { animate: false });
        } else {
          slideshow.previous(undefined, { animate: false });
        }
      };

      var originalResetVariant = productCard.resetVariant;
      productCard.resetVariant = Object.assign(function() {
        var slideshow = productCard.refs && productCard.refs.slideshow;
        if (!slideshow) return;
        var li = productCard.closest('[data-variant-color]');
        var c = li ? li.getAttribute('data-variant-color').toLowerCase() : null;
        if (!c) return;
        var slides = Array.from((slideshow.refs && slideshow.refs.slides) || []);
        var first = null;
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          var alt = img ? img.alt.toLowerCase().trim() : '';
          if (alt.indexOf(c) !== -1) { first = slides[i]; break; }
        }
        if (first) {
          slideshow.select({ id: first.getAttribute('slide-id') }, undefined, { animate: false });
        }
      }, { cancel: originalResetVariant.cancel || function() {} });
    }
  }

  function waitForProductCard(item) {
    var productCard = item.querySelector('product-card');
    if (!productCard) return;

    function tryApply(attempt) {
      attempt = attempt || 0;
      if (productCard.refs && productCard.refs.slideshow) {
        applyVariantCard(item);
        return;
      }
      if (attempt < 20) {
        setTimeout(function() { tryApply(attempt + 1); }, 50);
      }
    }

    if (customElements.get('product-card')) {
      tryApply();
    } else {
      customElements.whenDefined('product-card').then(function() {
        tryApply();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-grid__item[data-variant-id]').forEach(waitForProductCard);
    var grid = document.querySelector('[ref="grid"]');
    if (grid) {
      var morphTimeout = null;
      var observer = new MutationObserver(function() {
        clearTimeout(morphTimeout);
        morphTimeout = setTimeout(function() {
          document.querySelectorAll('.product-grid__item[data-variant-id]').forEach(waitForProductCard);
        }, 300);
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
